import { clockParts } from "../../core/format";

interface ClockProps {
	ms: number | null | undefined;
	timezone: string;
	className?: string;
	/** Set the meridiem small and top-aligned. Only worth it beside a large number. */
	superscript?: boolean;
}

export function Clock({ ms, timezone, className, superscript = false }: ClockProps) {
	const { time, meridiem } = clockParts(ms, timezone);
	return (
		<span className={className ? `clock ${className}` : "clock"}>
			{time}
			{meridiem ? <span className={superscript ? "clock__meridiem" : "clock__meridiemInline"}>{meridiem}</span> : null}
		</span>
	);
}
